import React from 'react';
import { useAppDispatch } from 'store/hooks';
import { setGlobalModal } from 'store/transitionSlice';
import { Resource } from 'store/types';
import EditModal from 'components/modal/editModal';

export const useEditHandler = ({ contextItem }: { contextItem: Resource }) => {
  const dispatch = useAppDispatch();

  return () => {
    dispatch(
      setGlobalModal(
        <EditModal
          onCancel={() => {
            dispatch(setGlobalModal(null));
          }}
          onConfirmLoader={true}
          item={contextItem}
        ></EditModal>
      )
    );
  };
};
